import { createContext } from 'react';


export const UserContextData = createContext({});